/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import { call, takeLatest, put } from 'redux-saga/effects';
import { pluginEndpoint, validationEndpoint } from '../data/prefabs';
import { selectInitedStateful } from '../../common/sagas';
import { CLOSE_SESSION } from '../actions';

export function* closeSession() {
  const stateful = yield call(selectInitedStateful);

  yield call([stateful, 'closeSession']);
  yield call([stateful, 'loadSessions'], { force: true });

  yield put(validationEndpoint.resetAction);
  yield put(pluginEndpoint.resetAction);

  if (window['exc-module-runtime']) {
    window['exc-module-runtime'].sidebar.collapsed = false;
  }
}

export default function* watchNavigateToSessionList() {
  yield takeLatest(CLOSE_SESSION, closeSession);
}
